"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supplyAndDemandDatabase = void 0;
const supplyAndDemandDatabase = exports.supplyAndDemandDatabase = {
  SUPPLY_AND_DEMAND_DATABASE: {
    en: {
      title: 'Supply & Demand Database',
      subtitle: 'Trade confidently with end-to-end chemicals supply chain data',
      description: 'Optimise decision-making with integrated upstream and downstream chemicals supply chain data, up to 2050.',
      list: ['Supply, demand and trade flow data showing current and planned production capacity', 'Updated daily with monthly and quarterly round-ups', 'Coverage of over 100 commodities in 175 countries', 'Segmented by plant, company, country or region']
    },
    zh: {
      title: '供需数据库',
      subtitle: '端对端的化工品供应链数据助您自信地开展交易',
      description: '获取综合上下游化工品供应链的完整数据（至2050年），优化决策制定。',
      list: ['供需和贸易流数据显示当前和计划内产能', '日度更新，月度和季度汇总', '涵盖175个国家和地区的100多种大宗品', '按装置、公司、国家或地区划分']
    }
  }
};